export default function HomeIcon() {
  return (
    <svg
      width="14"
      height="14"
      viewBox="0 0 14 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M5.08987 12.8489V10.8104C5.08987 10.29 5.5148 9.86818 6.03898 9.86818H7.95509C8.20681 9.86818 8.44822 9.96745 8.62621 10.1441C8.8042 10.3208 8.9042 10.5605 8.9042 10.8104V12.8489C8.90261 13.0652 8.98806 13.2732 9.1416 13.4268C9.29514 13.5803 9.50405 13.6666 9.72198 13.6666H11.0292C11.6398 13.6682 12.2259 13.4285 12.6581 13.0005C13.0904 12.5725 13.3334 11.9913 13.3334 11.3852V5.57789C13.3333 5.08829 13.1147 4.62387 12.7364 4.30976L8.28937 0.783892C7.51579 0.165687 6.40743 0.185648 5.65695 0.831299L1.31136 4.30976C0.915181 4.61461 0.678389 5.0804 0.666687 5.57789V11.3793C0.666687 12.6425 1.69827 13.6666 2.9708 13.6666H4.24821C4.70084 13.6666 5.06869 13.3041 5.07197 12.8548L5.08987 12.8489Z"
        fill="url(#paint0_linear_34_1479)"
      />
      <defs>
        <linearGradient
          id="paint0_linear_34_1479"
          x1="-3"
          y1="-2"
          x2="14"
          y2="16"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#F03750" />
          <stop offset="1" stopColor="#EB2E83" />
        </linearGradient>
      </defs>
    </svg>
  );
}
